var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 4C0.5 3.72386 0.723858 3.5 1 3.5H7C7.27614 3.5 7.5 3.72386 7.5 4C7.5 4.27614 7.27614 4.5 7 4.5H1C0.723858 4.5 0.5 4.27614 0.5 4Z",
    fill: "#929EB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1C0.5 0.723858 0.723858 0.5 1 0.5H7C7.27614 0.5 7.5 0.723858 7.5 1C7.5 1.27614 7.27614 1.5 7 1.5H1C0.723858 1.5 0.5 1.27614 0.5 1Z",
    fill: "#929EB5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 7C0.5 6.72386 0.723858 6.5 1 6.5H7C7.27614 6.5 7.5 6.72386 7.5 7C7.5 7.27614 7.27614 7.5 7 7.5H1C0.723858 7.5 0.5 7.27614 0.5 7Z",
    fill: "#929EB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDark);
export default __webpack_public_path__ + "static/media/dragDark.5939b6ff6296e61cdc85ccd9703979b2.svg";
export { ForwardRef as ReactComponent };